// @flow

import PublicRoute from './PublicRoute'

export default PublicRoute
